import { scrollToId } from "./Primitives";
import { NAV_LINKS } from "../../data/content";

export function Footer() {
  return (
    <footer id="footer" className="relative mt-8 overflow-hidden bg-ink text-paper">
      {/* large clean ghost mark, bottom-left */}
      <img
        src="/runloop_ghost.png"
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute -bottom-16 -left-10 h-[76%] w-auto object-contain opacity-[0.05] brightness-0 invert md:-left-4 md:h-[118%]"
      />

      <div className="relative mx-auto w-full max-w-[1440px] px-6 py-16 md:px-12 md:py-24 lg:px-24">
        <div className="flex justify-end">
          <div className="flex flex-wrap gap-14 sm:gap-20">
            <div>
              <div className="mb-5 font-mono-c text-[0.68rem] uppercase tracking-[0.2em] text-paper/50">Explore</div>
              <ul className="flex flex-col gap-3">
                {NAV_LINKS.map((l) => (
                  <li key={l.label}>
                    <button onClick={() => scrollToId(l.to)} className="text-paper/85 transition-colors hover:text-brand">
                      {l.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <div className="mb-5 font-mono-c text-[0.68rem] uppercase tracking-[0.2em] text-paper/50">Get in touch</div>
              <ul className="flex flex-col gap-3 text-paper/85">
                <li>
                  <button onClick={() => scrollToId("#looped-in")} className="transition-colors hover:text-brand">
                    Let&apos;s Talk
                  </button>
                </li>
                <li>
                  <a href="mailto:hello@run-loop.com" className="transition-colors hover:text-brand">
                    hello@run-loop.com
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/company/run-loop"
                    target="_blank"
                    rel="noreferrer"
                    className="transition-colors hover:text-brand"
                  >
                    LinkedIn
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-24 flex flex-col items-start justify-between gap-4 border-t border-white/15 pt-8 font-mono-c text-xs uppercase tracking-[0.14em] text-paper/50 md:flex-row md:items-center">
          <span>© {new Date().getFullYear()} RunLoop</span>
          <span className="normal-case">Mumbai, India</span>
        </div>
      </div>
    </footer>
  );
}
